import { FormatListBulleted } from '@mui/icons-material';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const commonButtonStyles = {
  width: '30px',
  height: '40px',
  border: '1px solid #707070',
};

const selectedButtonStyles = {
  backgroundColor: '#4ade80',
  color: 'white',
  '&:hover': {
    backgroundColor: '#3bc971',
  },
};

const unselectedButtonStyles = {
  backgroundColor: 'white',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
};

const toggleGroupStyles = {
  display: 'flex',
  borderRadius: '50px',
  '& .MuiToggleButton-root': {
    ...commonButtonStyles,
    '&.Mui-selected': selectedButtonStyles,
    '&:not(.Mui-selected)': unselectedButtonStyles,
  },
};

const ActivityToggle = ({ viewMode, setViewMode }) => {
  const handleViewModeChange = (_, newMode) => {
    if (newMode) setViewMode(newMode);
  };

  return (
    <ToggleButtonGroup
      className='activity-view-toggle'
      value={viewMode}
      exclusive
      onChange={handleViewModeChange}
      aria-label='view mode'
      sx={toggleGroupStyles}
    >
      <ToggleButton
        value='calendar'
        aria-label='calendar view'
        sx={{
          marginRight: '1px',
          borderTopLeftRadius: '20px',
          borderBottomLeftRadius: '20px',
        }}
      >
        <CalendarTodayIcon sx={{ color: 'black' }} />
      </ToggleButton>
      <ToggleButton
        value='list'
        aria-label='list view'
        sx={{
          borderTopRightRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <FormatListBulleted sx={{ color: 'black' }} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ActivityToggle;
